import { lazy } from 'react'

/**
 * #2846 — dev-only `/playground` route binding.
 *
 * `null` in a production build; a lazy-loaded `UiPlayground` everywhere else.
 * `App.tsx` registers `<Route path="playground">` only when this is non-null, so
 * in production the route is never mounted and `/playground` falls through to the
 * catch-all `NotFoundPage` (404). This is the web counterpart to the native
 * `/dev/catalog` `__DEV__` gate (#2593) and the enumeration target the
 * `oro-parity-design` skill points design-time agents at.
 *
 * Gate on build MODE, NOT `import.meta.env.DEV`/`PROD`: every environment ships
 * via `vite build`, which forces `NODE_ENV=production` (so `DEV` is false / `PROD`
 * true for the `devpages` + `qa` builds too). Only `--mode production`
 * (`build:prod`) sets `MODE === 'production'`; the dev server (`development`) and
 * the dev/qa builds (`devpages`/`qa`) must keep the showcase.
 *
 * Keep `import.meta.env.MODE` INLINE here (not behind a helper call): Vite
 * statically replaces it, so in a production build the ternary constant-folds to
 * `null`, Rollup dead-code-eliminates the dynamic `import()`, and `UiPlayground`
 * never enters the production bundle. Verified: `npm run build` (prod) emits no
 * `UiPlayground-*.js` chunk, and none of `UiPlayground.tsx`'s own content reaches
 * `dist/` — the identifier survives only inside this file's doc comment in
 * `index-*.js.map` (`vite.config.ts` sets `sourcemap: true`). `npm run build:qa`
 * keeps the chunk. Covered by `src/pages/uiPlaygroundRoute.test.ts` (pins the
 * binding) AND, since #2921, by `scripts/check-playground-dce.sh` — a post-build
 * assertion wired into `frontend-ci.yml` that fails if the prod bundle regains a
 * `UiPlayground-*.js` chunk or any of the showcase's own content, so this doc
 * comment is no longer the only thing guarding the DCE.
 */
export const uiPlaygroundRoute =
  import.meta.env.MODE !== 'production'
    ? lazy(() => import('./UiPlayground'))
    : null
